import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SearchAndFilters = ({ onSearch, onFilterChange, onSortChange }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  const fileTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'image', label: 'Images' },
    { value: 'video', label: 'Videos' },
    { value: 'cad', label: 'CAD Files' },
    { value: 'document', label: 'Documents' }
  ];

  const sortOptions = [
    { value: 'name', label: 'Name' },
    { value: 'date', label: 'Upload Date' },
    { value: 'size', label: 'File Size' },
    { value: 'type', label: 'File Type' }
  ];

  const projectOptions = [
    { value: 'all', label: 'All Projects' },
    { value: 'diamond-ring-collection', label: 'Diamond Ring Collection' },
    { value: 'wedding-bands-2024', label: 'Wedding Bands 2024' },
    { value: 'custom-necklaces', label: 'Custom Necklaces' },
    { value: 'vintage-restoration', label: 'Vintage Restoration' }
  ];

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchQuery(value);
    onSearch(value);
  };

  return (
    <div className="space-y-4">
      {/* Search Bar */}
      <div className="relative">
        <Input
          type="search"
          placeholder="Search files by name, project, or tags..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="pl-10"
        />
        <Icon
          name="Search"
          size={16}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
        />
      </div>
      {/* Filter Toggle */}
      <div className="flex items-center justify-between">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsFiltersOpen(!isFiltersOpen)}
          className="flex items-center space-x-2"
        >
          <Icon name="Filter" size={16} />
          <span>Filters</span>
          <Icon
            name="ChevronDown"
            size={16}
            className={`transition-transform ${isFiltersOpen ? 'rotate-180' : ''}`}
          />
        </Button>

        <div className="flex items-center space-x-2">
          <span className="text-sm text-muted-foreground">Sort by:</span>
          <Select
            options={sortOptions}
            value="date"
            onChange={(value) => onSortChange(value)}
            className="w-32"
          />
        </div>
      </div>
      {/* Filters Panel */}
      {isFiltersOpen && (
        <div className="bg-muted/30 rounded-lg p-4 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Select
              label="File Type"
              options={fileTypeOptions}
              value="all"
              onChange={(value) => onFilterChange('type', value)}
            />
            
            <Select
              label="Project"
              options={projectOptions}
              value="all"
              onChange={(value) => onFilterChange('project', value)}
            />
            
            <div className="space-y-2">
              <label className="text-sm font-medium text-foreground">Date Range</label>
              <div className="flex space-x-2">
                <Input
                  type="date"
                  placeholder="From"
                  onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
                  className="flex-1"
                />
                <Input
                  type="date"
                  placeholder="To"
                  onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
                  className="flex-1"
                />
              </div>
            </div>
          </div>

          {/* Quick Filters */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">Quick Filters</label>
            <div className="flex flex-wrap gap-2">
              {[
                { label: 'Recent (7 days)', value: 'recent' },
                { label: 'Large files (>10MB)', value: 'large' },
                { label: 'Untagged', value: 'untagged' },
                { label: 'Shared', value: 'shared' }
              ]?.map((filter) => (
                <Button
                  key={filter?.value}
                  variant="outline"
                  size="sm"
                  onClick={() => onFilterChange('quick', filter?.value)}
                  className="text-xs"
                >
                  {filter?.label}
                </Button>
              ))}
            </div>
          </div>

          {/* Clear Filters */}
          <div className="flex justify-end">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                // Clear all filters
                onFilterChange('clear', null);
              }}
            >
              Clear all filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchAndFilters;